export class ModelConfig {
  permittedAttribs: Array<string>;
}



// WEBPACK FOOTER //
// ./src/models/model-config.ts